import axios from 'axios';
import { useEffect, useState } from 'react';
import imagePreview from '../assets/image-preview.svg';
import useAlert from '../hooks/useAlert';
import useCheckVideo from '../hooks/useCheckVideo';
import { useTranslation } from 'react-i18next';

const initialForm = {
	description: '',
	uri: '',
	available: false,
	transferable: false, 
	viewable: false
};

const getVideoId = (url) => {
	const regex = /^https:\/\/www\.(youtube|youtube-nocookie)\.com\/(embed\/|watch\?v=)([a-zA-Z0-9_-]{11})(\?si=[a-zA-Z0-9_-]+)?$/;
	const m = regex.exec(url);
	if (m !== null) {
		return m[3];
	}
	return null;
}

const checkYouTubeVideo = (urlToValidate) => {
	// 正規式
	const regex = /^https:\/\/www\.(youtube|youtube-nocookie)\.com\/(embed\/|watch\?v=)([a-zA-Z0-9_-]{11})(\?si=[a-zA-Z0-9_-]+)?$/;

	// 驗證
	if (regex.test(urlToValidate)) {
		return true;
	}
	
	return false;
};

const UserAssetUpdate = (props) => {
	const { t, i18n } = useTranslation();
	const { show, close, getUserAssets, chosenUserAsset, getUserCollection } = props;
	const [form, setForm] = useState(initialForm);
	const { description, uri, available, transferable, viewable } = form;
	const { isVideo, mediaType, checkForVideo } = useCheckVideo();

	useEffect(() => {
		if (show) {
			setForm({
				description: chosenUserAsset.description,
				uri: chosenUserAsset.uri,
				available: chosenUserAsset.available,
				transferable: chosenUserAsset.transferable, 
				viewable: chosenUserAsset.viewable
			});
		}
	}, [show, chosenUserAsset.available, chosenUserAsset.uri, chosenUserAsset.description, chosenUserAsset.transferable, chosenUserAsset.viewable]);

	const inputChange = (event, field) => {
		if (['available', 'transferable', 'viewable'].includes(field)) {
			setForm({ ...form, [field]: event.target.checked });
		} else {
			setForm({ ...form, [field]: event.target.value });
		}
	}

	const token = localStorage.getItem('token');
	const { sendAlert } = useAlert();

	const clearForm = () => {
		setForm(initialForm);
	}

	const checkForm = (event) => {
		event.preventDefault();
		let hasError = false;

		if (!hasError) {
			updateUserAsset();
		}
	}

	const updateUserAsset = () => {
		axios.put(`/items/assets/update_asset/${chosenUserAsset.id}`, {
			description: form.description,
			uri: form.uri,
			available: form.available,
			transferable: form.transferable, 
			viewable: form.viewable
		}, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		}).then((response) => {
			const message = response.data.message;

			if (message === 'success') {
				close();
				getUserAssets();
				getUserCollection();
				clearForm();
				sendAlert(t('user_asset_update.msg_success'));
			}
		}).catch((error) => {
			const message = error.response.data.message;

			switch (message) {
				case "Data too long for column 'description' at row 1":
					sendAlert(t('user_asset_update.msg_too_long'));
					break;

				case 'The image has not been uploaded':
					sendAlert(t('user_asset_update.msg_url_must'));
					break;

				default:
					sendAlert(t('user_asset_update.msg_fail'));
					break;
			}
		});
	}

	const uploadImage = (event) => {
		const file = event.target.files[0];
		const formData = new FormData();

		formData.append('file', file, file.name);

		axios.post('items/upload_ipfs', formData, {
			headers: {
				Authorization: `Bearer ${token}`,
			}
		}).then((response) => {
			const message = response.data.message;
			const data = response.data.data;

			if (message === 'success') {
				setForm({ ...form, uri: data.ipfsUri });
			}
		}).catch((error) => {
			const message = error.response.data.message;

			switch (message) {
				default:
					sendAlert(t('user_asset_update.msg_upload_fail'));
					break;
			}
		});
	}

	useEffect(() => {
		if (uri) {
			checkForVideo(uri);
		}
	}, [uri, checkForVideo])

	return (
		<div className={`popup-wrap ${show ? 'active' : ''}`}>
			<div className='flow-wrap'>
				<div className='center-wrap'>
					<div className='close-popup' onClick={close}></div>
					<div className='popup-title'>{t('user_asset_update.title')}</div>

					<div className='form-wrap'>
						{isVideo ? (
							<video src={`${uri}#t=0.15`} preload='metadata' controls muted controlsList="nodownload" onContextMenu={(e) => e.preventDefault()}></video>
						) : (checkYouTubeVideo(uri.replace(/\s/g, '')) ? (
							<iframe 
								className='cover-preview'
								width="560" 
								height="315" 
								src={`https://www.youtube.com/embed/${getVideoId(uri.replace(/\s/g, ''))}`}
								title="YouTube video player" 
								frameBorder="0" 
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
								allowFullScreen>
							</iframe>
						) : (
							<div className='cover-preview' style={{ backgroundImage: `url(${uri || imagePreview})` }} onContextMenu={(e) => e.preventDefault()}>
								{/* <div className='text'>預覽圖片</div>
								<input type='file' onChange={uploadImage} accept='image/jpg, image/jpeg, image/png' /> */}
							</div>
						))}

						<form onSubmit={checkForm}>
							<div className='input-wrap'>
								<div className='label'>{t('user_asset_update.desc')}</div>
								<textarea value={description} onChange={(e) => { inputChange(e, 'description') }}></textarea>
							</div>

							<div className='input-wrap'>
								<div className='label'>{t('user_asset_update.link')}</div>
								<input type='text' value={uri} onChange={(e) => { inputChange(e, 'uri') }} />
							</div>

							<div className='input-wrap checkbox'>
								<div className='label'>{t('user_asset_update.if_listed')}</div>
								<input type='checkbox' checked={available} onChange={(e) => { inputChange(e, 'available') }} />
							</div>

							<div className='input-wrap checkbox'>
								<div className='label'>{t('user_asset_update.if_tradeable')}</div>
								<input type='checkbox' checked={transferable} onChange={(e) => { inputChange(e, 'transferable') }} />
							</div>

							<div className='input-wrap checkbox'>
								<div className='label'>{t('user_asset_update.if_public')}</div>
								<input type='checkbox' checked={viewable} onChange={(e) => { inputChange(e, 'viewable') }} />
							</div>

							<div className='button-wrap'>
								<button>{t('user_asset_update.btn_update')}</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	)
}

export default UserAssetUpdate;